import { render } from "./OrderVerificationPopup.vue?vue&type=template&id=98355768&scoped=true"
import script from "./OrderVerificationPopup.vue?vue&type=script&lang=js"
export * from "./OrderVerificationPopup.vue?vue&type=script&lang=js"

import "./OrderVerificationPopup.vue?vue&type=style&index=0&id=98355768&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ydsk-ph-h5-bankv3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98355768"]])

export default __exports__